import ApiResponse from "../models/ApiResponse";
import ProductSampleDTO from "../models/product/ProductSampleDTO";
import { ProductSample } from "../models/product/ProductSampleReference";
import TestRequestResponse from "../models/test-request/TestRequestResponse";
import Api from "./Api";

class ProductSamplesApi {
  constructor(private api: Api) {}

  public cloneThenAddProductSampleToTestRequest(
    requestId: string,
    productSampleId: number,
  ): ApiResponse<TestRequestResponse> {
    return this.api.post(
      `/test-request/v2/testrequests/${requestId}/product-samples/addCloned`,
      JSON.stringify(productSampleId),
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
  }

  public fetchProductSampleById(requestId: string, productSampleId: number): ApiResponse<ProductSampleDTO> {
    return this.api.get(`/test-request/v2/testrequests/${requestId}/product-samples/${productSampleId}`);
  }

  public deleteTestRequestProducts(requestId: string | null, payload: number[]): ApiResponse<TestRequestResponse> {
    return this.api.deleteByPayload(`/test-request/v2/testrequests/${requestId}/product-samples`, payload);
  }

  public updateProductSample(testRequestId: string, payload: ProductSample): ApiResponse<ProductSample> {
    return this.api.put(`/test-request/v2/testrequests/${testRequestId}/product-samples/${payload.id}`, payload);
  }

  public updateTestRequestProducts(requestId: string | null, payload: number[]): ApiResponse<TestRequestResponse> {
    return this.api.put(`/test-request/v2/testrequests/${requestId}/product-samples`, payload);
  }
}

export default ProductSamplesApi;
